export default __webpack_public_path__ + "static/icon-instagram-5c430acb1ecf80292e627ef4acfd0704.svg";